import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const AgeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16px", height: " 14px", fill: "none" }}
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M13.74 13.018H2.26002C1.92586 13.018 1.6054 12.8852 1.36908 12.6489C1.13275 12.4126 1 12.0921 1 11.7579V3.33424C1 3.00008 1.13274 2.67955 1.36908 2.4433C1.6054 2.20697 1.92586 2.07422 2.26002 2.07422H13.74C14.0741 2.07422 14.3946 2.20695 14.6309 2.4433C14.8672 2.67955 15 3.00008 15 3.33424V11.7595C14.9996 12.0934 14.8667 12.4135 14.6304 12.6495C14.3942 12.8855 14.0739 13.018 13.74 13.018Z"
        fill="white"
      />
      <path
        d="M3.20743 3.27323C3.11459 3.27323 3.02556 3.2363 2.95992 3.17065C2.89436 3.10509 2.85742 3.01606 2.85742 2.92323V1.22504C2.85742 1.10001 2.92417 0.984466 3.03242 0.921948C3.14076 0.859351 3.27417 0.859351 3.38244 0.921948C3.49078 0.984462 3.55744 1.1 3.55744 1.22504V2.92323C3.55744 3.01607 3.52059 3.10509 3.45495 3.17065C3.3893 3.2363 3.30027 3.27323 3.20744 3.27323H3.20743Z"
        fill="white"
      />
      <path
        d="M12.5453 3.27323C12.4525 3.27323 12.3635 3.2363 12.2978 3.17065C12.2322 3.10509 12.1953 3.01606 12.1953 2.92323V1.22504C12.1953 1.10001 12.2621 0.984466 12.3703 0.921948C12.4786 0.859351 12.6121 0.859351 12.7203 0.921948C12.8286 0.984462 12.8953 1.1 12.8953 1.22504V2.92323C12.8953 3.01607 12.8585 3.10509 12.7928 3.17065C12.7272 3.2363 12.6382 3.27323 12.5453 3.27323H12.5453Z"
        fill="white"
      />
      <path
        d="M15.4795 5.25H0.520539C0.379261 5.25 0.248598 5.16666 0.177979 5.03123C0.10734 4.8959 0.10734 4.7291 0.177979 4.59367C0.248618 4.45834 0.379271 4.375 0.520539 4.375H15.4795C15.6207 4.375 15.7514 4.45834 15.822 4.59367C15.8927 4.7291 15.8927 4.89587 15.822 5.03123C15.7514 5.16666 15.6207 5.25 15.4795 5.25Z"
        fill="#106048"
      />
    </SvgIcon>
  );
};

export const WeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14px", height: " 17px", fill: "none" }}
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
    >
      <path
        d="M11.3811 4.81324L7.32671 1.13965C6.85623 0.714011 6.07235 0.736531 5.62435 1.18449L1.95075 4.83573C0.673865 6.11261 -0.0428547 7.83728 0.00198528 9.65172C0.0243289 11.4661 0.763545 13.1686 2.0851 14.4229C3.31715 15.5877 4.95231 16.2149 6.67711 16.2149C8.40191 16.2149 10.0371 15.5654 11.2691 14.4006C12.5907 13.1462 13.3299 11.4437 13.3522 9.6294C13.3971 7.83736 12.7025 6.11253 11.381 4.81341L11.3811 4.81324ZM10.1939 13.2804C9.25311 14.1763 7.99875 14.6468 6.67703 14.6468C5.35547 14.6468 4.10111 14.154 3.16015 13.2804C2.15219 12.3173 1.56966 11.0181 1.54734 9.6292C1.525 8.24044 2.06251 6.91872 3.04815 5.93328L6.47535 2.50609L10.2833 5.93328C11.2689 6.91892 11.8064 8.24048 11.7841 9.6292C11.7844 11.0181 11.2244 12.3173 10.1939 13.2804H10.1939Z"
        fill="white"
      />
      <path
        d="M9.6566 6.58216L6.83422 4.02856C6.72219 3.91653 6.54297 4.00622 6.54297 4.16294V13.6381C6.54297 13.7277 6.6325 13.8173 6.72219 13.8173C7.14783 13.8173 7.57344 13.7502 7.97656 13.5933C11.1799 12.4061 11.7399 8.66529 9.65657 6.58209L9.6566 6.58216Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const HeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16px", height: " 16px", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.1783 1.04075C12.9026 0.765062 12.4537 0.765062 12.178 1.04075L11.5383 1.68051L12.7188 2.86103C12.8566 2.99887 12.8566 3.22154 12.7188 3.3594C12.6481 3.43009 12.5597 3.4619 12.4679 3.4619C12.376 3.4619 12.2876 3.42656 12.2169 3.3594L11.0364 2.17888L9.0005 4.21476L10.637 5.85126C10.7748 5.98911 10.7748 6.21177 10.637 6.34963C10.5663 6.42032 10.4779 6.45213 10.386 6.45213C10.2941 6.45213 10.2058 6.41679 10.1351 6.34963L8.4986 4.71314L6.46271 6.74902L7.64323 7.92955C7.78108 8.06739 7.78108 8.29006 7.64323 8.42792C7.57254 8.49861 7.48418 8.53042 7.39228 8.53042C7.30039 8.53042 7.21202 8.49507 7.14133 8.42792L5.96789 7.25092L3.93201 9.2868L5.5685 10.9233C5.70635 11.0611 5.70635 11.2838 5.5685 11.4217C5.49781 11.4924 5.40945 11.5242 5.31755 11.5242C5.22565 11.5242 5.13729 11.4888 5.0666 11.4217L3.4301 9.78517L1.04075 12.1745C0.765062 12.4502 0.765062 12.8991 1.04075 13.1748L3.65984 15.7939C3.93553 16.0696 4.38442 16.0696 4.6601 15.7939L15.7974 4.65662C16.073 4.38092 16.073 3.93203 15.7974 3.65635L13.1783 1.04075ZM3.91083 14.0442C3.84014 14.1149 3.75177 14.1468 3.65988 14.1468C3.56798 14.1468 3.47962 14.1114 3.40893 14.0442L2.79037 13.4257C2.65253 13.2878 2.65253 13.0652 2.79037 12.9273C2.92822 12.7895 3.15089 12.7895 3.28874 12.9273L3.9073 13.5459C4.04868 13.6837 4.04868 13.9064 3.91083 14.0442H3.91083Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const StrongFootIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21px", height: " 15px", fill: "none" }}
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
    >
      <path
        d="M15.1397 12.5692C15.1732 12.5831 15.2083 12.5925 15.2441 12.5971C15.4801 12.66 15.7256 12.5354 15.8145 12.3079C15.9035 12.0806 15.8074 11.8225 15.5917 11.7085L2.47481 4.76657C2.72488 4.29683 3.02798 3.73165 3.42754 3.06582C4.60907 1.05858 5.89154 0.845502 6.03335 0.826299C6.27612 0.796064 6.50263 0.953083 6.55957 1.19094C6.61446 1.42243 6.65629 1.65687 6.68453 1.89309C6.70908 2.022 6.78118 2.13722 6.88647 2.21557C6.93611 2.24385 8.72635 3.24302 9.51696 3.60383C9.88621 3.77475 10.9414 3.28712 11.5558 2.86776C11.6634 2.79465 11.7959 2.76817 11.9234 2.79464C12.0507 2.82062 12.162 2.89727 12.2319 3.00671L13.3284 4.71228L11.244 5.72947L11.2438 5.72941C11.0061 5.8463 10.9081 6.13356 11.0245 6.37154C11.0854 6.49667 11.1975 6.58912 11.3318 6.62531C11.4435 6.65502 11.5621 6.64376 11.666 6.59316L13.8531 5.52632L14.3561 6.30227L13.2913 6.80731C13.1106 6.89371 13.0025 7.08297 13.0198 7.28233C13.0373 7.48175 13.1765 7.64949 13.3694 7.70303C13.48 7.73287 13.5975 7.72193 13.7006 7.67258L14.88 7.11126C15.0895 7.43329 15.2752 7.71416 15.4091 7.91921C15.7971 8.44799 16.2558 8.92124 16.7721 9.32568C17.7968 10.2042 18.9616 11.1997 18.1978 13.1599C18.0555 13.5876 17.7453 13.9388 17.3382 14.1325C16.9678 14.2835 16.5574 14.3065 16.1725 14.1979C16.1197 14.1875 16.0679 14.1737 16.017 14.1563L15.966 14.1426L3.04092 7.29183C2.63128 7.07055 2.31746 6.70603 2.15963 6.26783C2.09941 6.07174 2.08438 5.86466 2.11576 5.66214L15.1397 12.5692Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const PreferredFormationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18px", height: "18px", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.7756 3.22571C11.5866 0.0367418 6.41484 0.0367418 3.22571 3.22571C0.0367432 6.41468 0.0367432 11.5865 3.22571 14.7756C6.41467 17.9646 11.5864 17.9646 14.7756 14.7756C17.9645 11.5866 17.9645 6.41484 14.7756 3.22571ZM9.00064 10.4162C8.2169 10.4162 7.58498 9.78065 7.58498 9.00059C7.58498 8.22052 8.22058 7.58492 9.00064 7.58492C9.7807 7.58492 10.4163 8.22052 10.4163 9.00059C10.4163 9.78065 9.78435 10.4162 9.00064 10.4162Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const CountriesCoachedInIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14px", height: "19px", fill: "none" }}
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
    >
      <path
        d="M14 7.83399C14 3.95465 10.7917 0.833984 7 0.833984C3.12067 0.833984 0 3.95482 0 7.83399V8.12565C0 8.15482 0.116667 9.17565 0.233333 9.61315C1.05 13.0258 3.82067 15.6215 7 18.0425C10.1792 15.6217 12.95 13.0258 13.7667 9.61315C13.8833 9.17565 14 8.18399 14 8.12565V7.83399ZM7 10.7507C5.39583 10.7507 4.08333 9.43815 4.08333 7.83399C4.08333 6.22982 5.39583 4.91732 7 4.91732C8.60417 4.91732 9.91667 6.22982 9.91667 7.83399C9.91667 9.43815 8.60417 10.7507 7 10.7507Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TeamsCoachedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16px", height: "16px", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.1783 1.04075C12.9026 0.765062 12.4537 0.765062 12.178 1.04075L11.5383 1.68051L12.7188 2.86103C12.8566 2.99887 12.8566 3.22154 12.7188 3.3594C12.6481 3.43009 12.5597 3.4619 12.4679 3.4619C12.376 3.4619 12.2876 3.42656 12.2169 3.3594L11.0364 2.17888L9.0005 4.21476L10.637 5.85126C10.7748 5.98911 10.7748 6.21177 10.637 6.34963C10.5663 6.42032 10.4779 6.45213 10.386 6.45213C10.2941 6.45213 10.2058 6.41679 10.1351 6.34963L8.4986 4.71314L6.46271 6.74902L7.64323 7.92955C7.78108 8.06739 7.78108 8.29006 7.64323 8.42792C7.57254 8.49861 7.48418 8.53042 7.39228 8.53042C7.30039 8.53042 7.21202 8.49507 7.14133 8.42792L5.96789 7.25092L3.93201 9.2868L5.5685 10.9233C5.70635 11.0611 5.70635 11.2838 5.5685 11.4217C5.49781 11.4924 5.40945 11.5242 5.31755 11.5242C5.22565 11.5242 5.13729 11.4888 5.0666 11.4217L3.4301 9.78517L1.04075 12.1745C0.765062 12.4502 0.765062 12.8991 1.04075 13.1748L3.65984 15.7939C3.93553 16.0696 4.38442 16.0696 4.6601 15.7939L15.7974 4.65662C16.073 4.38092 16.073 3.93203 15.7974 3.65635L13.1783 1.04075ZM3.91083 14.0442C3.84014 14.1149 3.75177 14.1468 3.65988 14.1468C3.56798 14.1468 3.47962 14.1114 3.40893 14.0442L2.79037 13.4257C2.65253 13.2878 2.65253 13.0652 2.79037 12.9273C2.92822 12.7895 3.15089 12.7895 3.28874 12.9273L3.9073 13.5459C4.04868 13.6837 4.04868 13.9064 3.91083 14.0442H3.91083Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const RepresentedClubIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16px", height: " 18px", fill: "none" }}
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M15.272 4.38851L8.23191 0.887899C8.08758 0.816013 7.92125 0.816013 7.77692 0.887899L0.736791 4.38851C0.627998 4.44087 0.538302 4.53047 0.481489 4.64325C0.424676 4.75616 0.404004 4.88599 0.422742 5.01284L1.50584 12.0141C1.53001 12.1642 1.60774 12.2982 1.72246 12.3874L7.67949 17.0549C7.7722 17.128 7.88414 17.1673 7.99897 17.1673C8.11381 17.1673 8.22574 17.128 8.31845 17.0549L14.2755 12.3874C14.3902 12.2982 14.4679 12.1642 14.4921 12.0141L15.5752 5.01284C15.5948 4.88743 15.5757 4.7585 15.5209 4.64585C15.4662 4.53307 15.3788 4.44282 15.272 4.38851L15.272 4.38851ZM13.7719 6.04544L13.0028 11.022V11.0221C12.9786 11.1723 12.9009 11.3063 12.7862 11.3955L8.32385 14.8961C8.23113 14.9692 8.1192 15.0085 8.00437 15.0085C7.88954 15.0085 7.77759 14.9692 7.68488 14.8961L3.22253 11.3955C3.10781 11.3063 3.03008 11.1723 3.00591 11.0221L2.23685 6.04524C2.21775 5.91917 2.23757 5.78972 2.29342 5.67707C2.34915 5.56429 2.43775 5.4743 2.54558 5.42104L7.77693 2.81888C7.92127 2.74699 8.0876 2.74699 8.23193 2.81888L13.4633 5.42104H13.4632C13.571 5.4743 13.6596 5.56429 13.7153 5.67707C13.7712 5.78972 13.791 5.91917 13.7719 6.04524L13.7719 6.04544Z"
        fill="white"
      />
      <path
        d="M3.375 6.29089L4.04104 10.5967L8.00518 13.7006L11.9693 10.5967L12.6354 6.29089L8.00527 3.99219L3.375 6.29089Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalCareerTransfersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "16px",
        height: "18px",
        fill: "none",
      }}
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M15.272 4.38851L8.23191 0.887899C8.08758 0.816013 7.92125 0.816013 7.77692 0.887899L0.736791 4.38851C0.627998 4.44087 0.538302 4.53047 0.481489 4.64325C0.424676 4.75616 0.404004 4.88599 0.422742 5.01284L1.50584 12.0141C1.53001 12.1642 1.60774 12.2982 1.72246 12.3874L7.67949 17.0549C7.7722 17.128 7.88414 17.1673 7.99897 17.1673C8.11381 17.1673 8.22574 17.128 8.31845 17.0549L14.2755 12.3874C14.3902 12.2982 14.4679 12.1642 14.4921 12.0141L15.5752 5.01284C15.5948 4.88743 15.5757 4.7585 15.5209 4.64585C15.4662 4.53307 15.3788 4.44282 15.272 4.38851L15.272 4.38851ZM13.7719 6.04544L13.0028 11.022V11.0221C12.9786 11.1723 12.9009 11.3063 12.7862 11.3955L8.32385 14.8961C8.23113 14.9692 8.1192 15.0085 8.00437 15.0085C7.88954 15.0085 7.77759 14.9692 7.68488 14.8961L3.22253 11.3955C3.10781 11.3063 3.03008 11.1723 3.00591 11.0221L2.23685 6.04524C2.21775 5.91917 2.23757 5.78972 2.29342 5.67707C2.34915 5.56429 2.43775 5.4743 2.54558 5.42104L7.77693 2.81888C7.92127 2.74699 8.0876 2.74699 8.23193 2.81888L13.4633 5.42104H13.4632C13.571 5.4743 13.6596 5.56429 13.7153 5.67707C13.7712 5.78972 13.791 5.91917 13.7719 6.04524L13.7719 6.04544Z"
        fill="white"
      />
      <path
        d="M3.375 6.29089L4.04104 10.5967L8.00518 13.7006L11.9693 10.5967L12.6354 6.29089L8.00527 3.99219L3.375 6.29089Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalScoutedPlayersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18px", height: "18px", fill: "none" }}
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M5.54122 5.74542e-06C6.34291 -0.00155674 7.11243 0.315629 7.68013 0.881496C8.24795 1.44749 8.56762 2.21598 8.56865 3.01767C8.56969 3.8195 8.25199 4.58876 7.68573 5.15618C7.11933 5.72361 6.35071 6.04277 5.54892 6.04327C4.74723 6.04379 3.97824 5.72557 3.41105 5.15892C2.84399 4.59212 2.52539 3.8234 2.52539 3.02157C2.52539 2.22118 2.84296 1.45349 3.40831 0.887096C3.97381 0.320569 4.74086 0.00157239 5.54122 5.74542e-06V5.74542e-06Z"
        fill="white"
      />
      <path
        d="M0.834151 12.3032C0.835713 11.0552 1.33218 9.85873 2.2146 8.9763C3.09716 8.09374 4.29361 7.59728 5.54164 7.59571C6.79019 7.59324 7.98784 8.09114 8.8666 8.97827C9.1748 9.2836 9.4381 9.63126 9.64823 10.0108C10.0387 10.7133 10.2398 11.5053 10.2316 12.3091V14.6949H0.833984L0.834151 12.3032ZM17.1673 14.689H11.719V12.3032C11.7177 12.0595 11.7022 11.816 11.6723 11.5741C11.6723 11.4983 11.6723 11.4224 11.6373 11.3466C11.6373 11.1833 11.5789 11.0199 11.5439 10.8566C11.5089 10.6934 11.503 10.6875 11.4739 10.6C11.4447 10.5125 11.3805 10.2966 11.3222 10.1508C11.2638 10.0049 11.2638 9.99323 11.2347 9.91745L11.1996 9.82995H11.1999C11.9478 9.27838 12.8742 9.02475 13.7988 9.11812C14.7234 9.21161 15.5803 9.64545 16.2029 10.3354C16.8254 11.0254 17.1691 11.9223 17.1673 12.8516L17.1673 14.689Z"
        fill="white"
      />
      <path
        d="M13.4159 3.42383C14.0038 3.42383 14.5675 3.65742 14.9832 4.07315C15.3989 4.48878 15.6325 5.05258 15.6325 5.64047C15.6325 6.22836 15.3989 6.79229 14.9832 7.20789C14.5675 7.62365 14.0038 7.85711 13.4159 7.85711C12.828 7.85711 12.264 7.62365 11.8484 7.20789C11.4327 6.79226 11.1992 6.22833 11.1992 5.64047C11.2007 5.05311 11.4348 4.49022 11.8501 4.07485C12.2655 3.65949 12.8284 3.42539 13.4159 3.42383Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const LocationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14px", height: "19px", fill: "none" }}
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
    >
      <path
        d="M14 7.83399C14 3.95465 10.7917 0.833984 7 0.833984C3.12067 0.833984 0 3.95482 0 7.83399V8.12565C0 8.15482 0.116667 9.17565 0.233333 9.61315C1.05 13.0258 3.82067 15.6215 7 18.0425C10.1792 15.6217 12.95 13.0258 13.7667 9.61315C13.8833 9.17565 14 8.18399 14 8.12565V7.83399ZM7 10.7507C5.39583 10.7507 4.08333 9.43815 4.08333 7.83399C4.08333 6.22982 5.39583 4.91732 7 4.91732C8.60417 4.91732 9.91667 6.22982 9.91667 7.83399C9.91667 9.43815 8.60417 10.7507 7 10.7507Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalRepresentedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18px", height: "14px", fill: "none" }}
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
    >
      <path
        d="M12.7654 0.0013937C12.658 0.0142339 12.5773 0.105333 12.5776 0.213327V2.74435H7.10991C6.99313 2.74502 6.89865 2.8395 6.89798 2.95628V5.88103C6.89865 5.99781 6.99313 6.09229 7.10991 6.09296H12.5776V8.62399H12.5778C12.5799 8.70914 12.6326 8.78469 12.7117 8.81619C12.7906 8.84781 12.8809 8.82943 12.9412 8.76928L17.1072 4.56695C17.1874 4.48436 17.1874 4.35299 17.1072 4.27027L12.9412 0.0620501C12.895 0.016096 12.8302 -0.00620801 12.7655 0.00149771L12.7654 0.0013937ZM5.19043 4.75493C5.14231 4.76007 5.09744 4.78142 5.06311 4.81548L0.897104 9.01782C0.85669 9.05782 0.833984 9.1123 0.833984 9.1692C0.833984 9.22597 0.856692 9.28057 0.897104 9.32058L5.06311 13.5229C5.1242 13.5836 5.21584 13.6014 5.29531 13.5683C5.37465 13.5352 5.42642 13.4576 5.42642 13.3715V10.8464H10.8945C11.0113 10.8459 11.1057 10.7513 11.1064 10.6345V7.70989C11.1078 7.65271 11.086 7.59743 11.0461 7.55648C11.0063 7.51552 10.9516 7.49214 10.8945 7.49187H5.42642V4.96677V4.9669C5.42642 4.90635 5.40074 4.84863 5.35573 4.80822C5.31072 4.76781 5.25057 4.74848 5.19043 4.75497V4.75493Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TryoutIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 0.5C12.1523 0.5 15.5 3.84768 15.5 8C15.5 12.1523 12.1523 15.5 7.99998 15.5C3.84766 15.5 0.499981 12.1523 0.499981 8C0.499981 3.84768 3.84766 0.5 7.99998 0.5ZM5.09346 11.7888L2.91356 10.6729L2.52434 12.2301L4.4707 14.3321L6.05378 14.0467L5.09357 11.789L5.09346 11.7888ZM3.19899 6.85813L2.9914 4.41864L1.46022 4.91177L0.707597 7.66266L1.77161 8.85639L3.19899 6.85813ZM8.15569 3.27688L5.9239 2.29073L6.88411 0.993205L9.71295 1.17484L10.5175 2.57617L8.15569 3.27688ZM12.7752 6.75447L12.9568 4.28903L14.5139 4.78215L15.2665 7.53305L14.1766 8.75273L12.7753 6.75447H12.7752ZM11.2959 11.5296L13.4758 10.4137L13.865 11.9708L11.9186 14.0729L10.3355 13.7874L11.2957 11.5297L11.2959 11.5296ZM7.99987 5.43098L10.6988 7.4033L9.66075 10.5694H6.33878L5.30073 7.4033L7.99987 5.43098Z"
        fill="#106048"
      />
    </SvgIcon>
  );
};

export const JobsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M19 6.76756V9.68422C16.6248 10.5351 13.6752 11.0212 10.5 11.0212C7.3248 11.0212 4.3752 10.5351 2 9.68422V6.76756C2 6.23244 2.4504 5.79533 3 5.79533H7.1248V5.06578C7.1248 3.94733 8.0752 3 9.2496 3H11.7496C12.9248 3 13.8744 3.94811 13.8744 5.06578V5.79533H17.9992C18.5496 5.79533 19 6.23322 19 6.76756ZM8.3752 5.06578V5.79533H12.6256V5.06578C12.6256 4.60378 12.2256 4.21489 11.7504 4.21489H9.2504C8.7752 4.21489 8.3752 4.60378 8.3752 5.06578ZM9.2504 9.51389V10C9.2504 10.1462 9.3504 10.2434 9.5008 10.2434H11.5008C11.6512 10.2434 11.7512 10.1462 11.7512 10V9.51389C11.7512 9.36767 11.6512 9.27044 11.5008 9.27044H9.5008C9.3504 9.27044 9.2504 9.36767 9.2504 9.51389ZM2 16.0278V10.7288C4.4 11.5307 7.3248 11.9927 10.5 11.9927C13.6752 11.9927 16.6 11.5307 19 10.7288V16.0278C19 16.5629 18.5496 17 18 17H3C2.4496 17 2 16.5621 2 16.0278ZM11.7504 13.5241V13.038C11.7504 12.8918 11.6504 12.7946 11.5 12.7946H9.5C9.3496 12.7946 9.2496 12.8918 9.2496 13.038V13.5241C9.2496 13.6703 9.3496 13.7676 9.5 13.7676H11.5C11.6504 13.7676 11.7504 13.6703 11.7504 13.5241Z"
        fill="#106048"
      />
    </SvgIcon>
  );
};

export const ArrowRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.30272 17.2937C8.91434 16.9048 8.914 16.2749 9.30195 15.8856L13.1738 12L9.30195 8.11443C8.914 7.72511 8.91434 7.09524 9.30272 6.70634C9.69214 6.31639 10.3241 6.31639 10.7135 6.70634L16 12L10.7135 17.2937C10.3241 17.6836 9.69214 17.6836 9.30272 17.2937Z"
        fill="#A0A0A0"
      />
    </SvgIcon>
  );
};

export const CertificateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M37.9044 5.14353L6.591 8.75L10.9141 46.2855L42.2275 42.6791L37.9044 5.14353Z" fill="#CFCFCF" />
      <path d="M36.7993 4.20024L6.36835 7.70508L10.6914 45.2406L41.1224 41.7358L36.7993 4.20024Z" fill="#CFCFCF" />
      <path d="M35.5739 3.32329L5.14288 6.82812L9.46598 44.3637L39.897 40.8588L35.5739 3.32329Z" fill="#E7E7E7" />
      <path d="M19.0598 8.3724L8.84534 9.54883L10.2072 21.373L20.4216 20.1966L19.0598 8.3724Z" fill="white" />
      <path
        d="M9.97101 19.3068C9.97101 19.3068 10.2855 16.7213 12.6693 15.7347C15.0532 14.748 18.4477 14.5584 20.1833 18.1353L20.4234 20.1975L10.2111 21.3738L9.97101 19.3068Z"
        fill="#106048"
      />
      <path d="M13.9399 12.043L13.7118 15.3631L15.7811 16.3209L14.9793 12.9432L13.9399 12.043Z" fill="#F4A28C" />
      <path
        opacity="0.31"
        d="M15.1254 13.4661C14.8933 13.4291 14.6771 13.3248 14.5037 13.166C14.6158 13.6344 14.9015 14.0428 15.3031 14.3087L15.1254 13.4661Z"
        fill="#CE8172"
      />
      <path
        d="M15.3951 11.654C15.5679 12.1911 15.668 12.749 15.6928 13.3128C15.69 13.3803 15.6738 13.4466 15.6452 13.5077C15.6166 13.5689 15.576 13.6238 15.526 13.6691C15.4759 13.7145 15.4174 13.7494 15.3537 13.7719C15.29 13.7944 15.2224 13.804 15.155 13.8001C14.9382 13.8069 14.7241 13.7513 14.5381 13.6397C14.3521 13.5282 14.2021 13.3656 14.1059 13.1712L13.621 12.3741C13.5384 12.2044 13.5107 12.0131 13.5416 11.8268C13.5726 11.6406 13.6607 11.4686 13.7938 11.3347C14.2596 10.8041 15.2294 11.0418 15.3951 11.654Z"
        fill="#F4A28C"
      />
      <path
        d="M15.5547 12.2598L15.9172 12.5791C15.9394 12.5968 15.9565 12.62 15.9668 12.6465C15.977 12.6729 15.9801 12.7016 15.9758 12.7296C15.9714 12.7577 15.9596 12.7841 15.9418 12.8061C15.9239 12.8281 15.9005 12.845 15.874 12.8551L15.5115 13.0136L15.5547 12.2598Z"
        fill="#F4A28C"
      />
      <path
        d="M13.7705 13.4164L13.2736 12.1345C13.2736 12.1345 12.4934 12.0889 12.6662 11.5631C12.8391 11.0374 13.1848 11.3231 13.132 10.7589C13.0791 10.1948 13.5329 10.0147 13.9002 10.3004C14.2675 10.5861 14.0634 10.154 14.4691 10.0459C14.8748 9.93789 15.0045 10.1107 15.0477 10.4228C15.0909 10.7349 15.6502 10.3364 15.8471 10.7157C16.0439 11.095 16.1136 11.4695 15.0909 11.6544C14.0682 11.8392 14.9132 12.5882 13.7705 13.4164Z"
        fill="#707070"
      />
      <path
        d="M14.5323 12.7305C14.5323 12.7305 14.4386 12.3512 14.1578 12.4472C13.8769 12.5432 14.0137 13.0906 14.4146 13.0546L14.5323 12.7305Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.08"
        d="M9.97101 19.3069C9.97101 19.3069 11.1329 21.1626 13.572 19.8351C16.011 18.5075 18.7405 17.8065 20.3202 19.3549L20.4162 20.1856L10.2039 21.3619L9.97101 19.3069Z"
        fill="#111111"
      />
      <path d="M28.9602 7.58796L21.4145 8.45703L21.6166 10.2123L29.1624 9.34323L28.9602 7.58796Z" fill="white" />
      <path d="M29.3518 11.0001L21.8061 11.8691L22.0083 13.6244L29.554 12.7553L29.3518 11.0001Z" fill="white" />
      <path
        opacity="0.11"
        d="M20.6745 22.3869L13.9611 23.1602L14.1632 24.9154L20.8766 24.1422L20.6745 22.3869Z"
        fill="#CFCFCF"
      />
      <path
        opacity="0.11"
        d="M21.269 27.5686L14.5555 28.3418L14.7577 30.0971L21.4711 29.3239L21.269 27.5686Z"
        fill="#CFCFCF"
      />
      <path
        opacity="0.11"
        d="M33.6037 20.8967L26.8903 21.6699L27.0925 23.4252L33.8059 22.652L33.6037 20.8967Z"
        fill="#CFCFCF"
      />
      <path
        opacity="0.11"
        d="M34.1999 26.0803L27.4865 26.8535L27.6886 28.6088L34.402 27.8356L34.1999 26.0803Z"
        fill="#CFCFCF"
      />
      <path d="M33.7208 13.9543L22.1995 15.2812L22.7349 19.9294L34.2562 18.6024L33.7208 13.9543Z" fill="white" />
      <path d="M35.6651 30.8261L11.6519 33.5918L12.4226 40.2838L36.4359 37.5181L35.6651 30.8261Z" fill="white" />
      <path d="M34.813 21.4296L10.7997 24.1953L11.5704 30.8873L35.5837 28.1216L34.813 21.4296Z" fill="white" />
      <path
        d="M29.8707 3.97216L29.7987 3.43682C29.7528 3.02982 29.8699 2.62118 30.1246 2.30038C30.3793 1.97958 30.7507 1.77275 31.1575 1.72517V1.72517C31.3589 1.70175 31.5631 1.71827 31.7581 1.77377C31.9532 1.82927 32.1354 1.92268 32.2944 2.04864C32.4534 2.17461 32.5859 2.33066 32.6845 2.50789C32.7832 2.68512 32.8459 2.88005 32.8691 3.08153L33.4741 8.34373C33.4915 8.49241 33.4794 8.64305 33.4384 8.78704C33.3975 8.93102 33.3286 9.06552 33.2356 9.18282C33.1426 9.30012 33.0274 9.39792 32.8965 9.47062C32.7657 9.54331 32.6218 9.58948 32.473 9.60647V9.60647C32.1729 9.64093 31.8713 9.55487 31.6346 9.36717C31.3978 9.17948 31.2452 8.9055 31.2103 8.6054L30.8838 5.77264"
        stroke="#111111"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
};

export const ClosePopupIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "12px",
        height: "12px",
        fill: "none",
      }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M11 1L1 11M1 1L11 11" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const EditProfilePhoto = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "16px",
        height: "12px",
        fill: "none",
      }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.9877 1.16249C11.871 0.279169 13.3032 0.279169 14.1865 1.16249L14.8375 1.81348C15.7208 2.6968 15.7208 4.12896 14.8375 5.01228L5.18418 14.6656L0.509443 15.4906L1.3344 10.8158L10.9877 1.16249Z"
        fill="white"
        stroke="#106048"
      />
    </SvgIcon>
  );
};

export const AndroidIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "148px",
        height: "41px",
        fill: "none",
      }}
      width="148"
      height="41"
      viewBox="0 0 148 41"
      fill="none"
    >
      <rect y="0.5" width="147.866" height="40" rx="20" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1834 8.4652C16.0652 8.7327 16 9.06046 16 9.44172V31.5577C16 31.9398 16.0653 32.2676 16.1836 32.535L28.2175 20.4993L16.1834 8.4652ZM16.8786 33.2542C17.3246 33.4451 17.9065 33.3845 18.541 33.0247L32.6981 24.9799L28.9246 21.2065L16.8786 33.2542ZM33.6005 24.4682L38.042 21.9447C39.439 21.1497 39.439 19.8507 38.042 19.0567L33.5986 16.5318L29.6317 20.4993L33.6005 24.4682ZM32.6968 16.0194L18.541 7.97572C17.9065 7.61515 17.3246 7.55498 16.8785 7.74612L28.9246 19.7922L32.6968 16.0194Z"
        fill="black"
      />
      <path
        d="M53.1557 10.2285C53.1557 11.0665 52.9077 11.7335 52.4107 12.2315C51.8467 12.8235 51.1107 13.1195 50.2067 13.1195C49.3407 13.1195 48.6037 12.8195 47.9987 12.2195C47.3927 11.6185 47.0897 10.8745 47.0897 9.98654C47.0897 9.09754 47.3927 8.35354 47.9987 7.75354C48.6037 7.15254 49.3407 6.85254 50.2067 6.85254C50.6367 6.85254 51.0477 6.93654 51.4377 7.10354C51.8287 7.27154 52.1417 7.49454 52.3757 7.77354L51.8487 8.30154C51.4517 7.82654 50.9047 7.58954 50.2057 7.58954C49.5737 7.58954 49.0277 7.81154 48.5667 8.25554C48.1057 8.69954 47.8757 9.27654 47.8757 9.98554C47.8757 10.6945 48.1057 11.2715 48.5667 11.7155C49.0277 12.1595 49.5737 12.3815 50.2057 12.3815C50.8757 12.3815 51.4347 12.1585 51.8817 11.7115C52.1717 11.4205 52.3397 11.0155 52.3847 10.4965H50.2057V9.77554H53.1127C53.1427 9.93254 53.1557 10.0835 53.1557 10.2285Z"
        fill="black"
      />
      <path
        d="M57.7658 7.7226H55.0338V9.6246H57.4978V10.3456H55.0338V12.2476H57.7658V12.9856H54.2628V6.9856H57.7658V7.7226Z"
        fill="black"
      />
      <path d="M61.0167 12.9856H60.2457V7.7226H58.5697V6.9856H62.6927V7.7226H61.0167V12.9856Z" fill="black" />
      <path d="M65.6757 12.9856V6.9856H66.4467V12.9856H65.6757Z" fill="black" />
      <path d="M69.8658 12.9856H69.0948V7.7226H67.4188V6.9856H71.5418V7.7226H69.8658V12.9856Z" fill="black" />
      <path
        d="M79.3466 12.2106C78.7566 12.8166 78.0236 13.1196 77.1466 13.1196C76.2696 13.1196 75.5366 12.8166 74.9476 12.2106C74.3576 11.6046 74.0636 10.8626 74.0636 9.98559C74.0636 9.10859 74.3576 8.36659 74.9476 7.76059C75.5366 7.15459 76.2696 6.85059 77.1466 6.85059C78.0186 6.85059 78.7506 7.15559 79.3426 7.76459C79.9346 8.37359 80.2306 9.11359 80.2306 9.98559C80.2306 10.8626 79.9356 11.6046 79.3466 12.2106ZM75.5166 11.7076C75.9606 12.1576 76.5036 12.3816 77.1466 12.3816C77.7896 12.3816 78.3336 12.1566 78.7766 11.7076C79.2206 11.2576 79.4436 10.6836 79.4436 9.98559C79.4436 9.28759 79.2206 8.71359 78.7766 8.26359C78.3336 7.81359 77.7896 7.58959 77.1466 7.58959C76.5036 7.58959 75.9606 7.81459 75.5166 8.26359C75.0736 8.71359 74.8506 9.28759 74.8506 9.98559C74.8506 10.6836 75.0736 11.2576 75.5166 11.7076Z"
        fill="black"
      />
      <path
        d="M81.3126 12.9856V6.9856H82.2506L85.1666 11.6526H85.1996L85.1666 10.4966V6.9856H85.9376V12.9856H85.1326L82.0816 8.0916H82.0486L82.0816 9.2476V12.9856H81.3126Z"
        fill="black"
      />
      <path
        d="M53.1557 10.2285C53.1557 11.0665 52.9077 11.7335 52.4107 12.2315C51.8467 12.8235 51.1107 13.1195 50.2067 13.1195C49.3407 13.1195 48.6037 12.8195 47.9987 12.2195C47.3927 11.6185 47.0897 10.8745 47.0897 9.98654C47.0897 9.09754 47.3927 8.35354 47.9987 7.75354C48.6037 7.15254 49.3407 6.85254 50.2067 6.85254C50.6367 6.85254 51.0477 6.93654 51.4377 7.10354C51.8287 7.27154 52.1417 7.49454 52.3757 7.77354L51.8487 8.30154C51.4517 7.82654 50.9047 7.58954 50.2057 7.58954C49.5737 7.58954 49.0277 7.81154 48.5667 8.25554C48.1057 8.69954 47.8757 9.27654 47.8757 9.98554C47.8757 10.6945 48.1057 11.2715 48.5667 11.7155C49.0277 12.1595 49.5737 12.3815 50.2057 12.3815C50.8757 12.3815 51.4347 12.1585 51.8817 11.7115C52.1717 11.4205 52.3397 11.0155 52.3847 10.4965H50.2057V9.77554H53.1127C53.1427 9.93254 53.1557 10.0835 53.1557 10.2285Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M57.7658 7.7226H55.0338V9.6246H57.4978V10.3456H55.0338V12.2476H57.7658V12.9856H54.2628V6.9856H57.7658V7.7226Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M61.0167 12.9856H60.2457V7.7226H58.5697V6.9856H62.6927V7.7226H61.0167V12.9856Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.6757 12.9856V6.9856H66.4467V12.9856H65.6757Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M69.8658 12.9856H69.0948V7.7226H67.4188V6.9856H71.5418V7.7226H69.8658V12.9856Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M79.3466 12.2106C78.7566 12.8166 78.0236 13.1196 77.1466 13.1196C76.2696 13.1196 75.5366 12.8166 74.9476 12.2106C74.3576 11.6046 74.0636 10.8626 74.0636 9.98559C74.0636 9.10859 74.3576 8.36659 74.9476 7.76059C75.5366 7.15459 76.2696 6.85059 77.1466 6.85059C78.0186 6.85059 78.7506 7.15559 79.3426 7.76459C79.9346 8.37359 80.2306 9.11359 80.2306 9.98559C80.2306 10.8626 79.9356 11.6046 79.3466 12.2106ZM75.5166 11.7076C75.9606 12.1576 76.5036 12.3816 77.1466 12.3816C77.7896 12.3816 78.3336 12.1566 78.7766 11.7076C79.2206 11.2576 79.4436 10.6836 79.4436 9.98559C79.4436 9.28759 79.2206 8.71359 78.7766 8.26359C78.3336 7.81359 77.7896 7.58959 77.1466 7.58959C76.5036 7.58959 75.9606 7.81459 75.5166 8.26359C75.0736 8.71359 74.8506 9.28759 74.8506 9.98559C74.8506 10.6836 75.0736 11.2576 75.5166 11.7076Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M81.3126 12.9856V6.9856H82.2506L85.1666 11.6526H85.1996L85.1666 10.4966V6.9856H85.9376V12.9856H85.1326L82.0816 8.0916H82.0486L82.0816 9.2476V12.9856H81.3126Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M74.1837 21.8231C71.8317 21.8231 69.9147 23.6121 69.9147 26.0761C69.9147 28.5251 71.8317 30.3291 74.1837 30.3291C76.5367 30.3291 78.4537 28.5251 78.4537 26.0761C78.4527 23.6121 76.5357 21.8231 74.1837 21.8231ZM74.1837 28.6551C72.8947 28.6551 71.7837 27.5921 71.7837 26.0771C71.7837 24.5461 72.8957 23.4991 74.1837 23.4991C75.4727 23.4991 76.5837 24.5461 76.5837 26.0771C76.5837 27.5911 75.4727 28.6551 74.1837 28.6551ZM64.8697 21.8231C62.5177 21.8231 60.6007 23.6121 60.6007 26.0761C60.6007 28.5251 62.5177 30.3291 64.8697 30.3291C67.2227 30.3291 69.1397 28.5251 69.1397 26.0761C69.1397 23.6121 67.2227 21.8231 64.8697 21.8231ZM64.8697 28.6551C63.5807 28.6551 62.4697 27.5921 62.4697 26.0771C62.4697 24.5461 63.5817 23.4991 64.8697 23.4991C66.1587 23.4991 67.2697 24.5461 67.2697 26.0771C67.2707 27.5911 66.1587 28.6551 64.8697 28.6551ZM53.7917 23.1291V24.9331H58.1097C57.9807 25.9481 57.6427 26.6891 57.1267 27.2041C56.4987 27.8321 55.5157 28.5251 53.7917 28.5251C51.1337 28.5251 49.0557 26.3821 49.0557 23.7241C49.0557 21.0661 51.1337 18.9231 53.7917 18.9231C55.2257 18.9231 56.2727 19.4871 57.0457 20.2121L58.3187 18.9391C57.2387 17.9081 55.8057 17.1191 53.7917 17.1191C50.1507 17.1191 47.0897 20.0831 47.0897 23.7241C47.0897 27.3651 50.1507 30.3291 53.7917 30.3291C55.7567 30.3291 57.2397 29.6841 58.3987 28.4761C59.5907 27.2841 59.9617 25.6081 59.9617 24.2551C59.9617 23.8371 59.9297 23.4501 59.8647 23.1281H53.7917V23.1291ZM99.0997 24.5301C98.7457 23.5801 97.6657 21.8231 95.4587 21.8231C93.2677 21.8231 91.4467 23.5471 91.4467 26.0761C91.4467 28.4601 93.2517 30.3291 95.6677 30.3291C97.6167 30.3291 98.7447 29.1371 99.2127 28.4441L97.7627 27.4771C97.2797 28.1861 96.6187 28.6531 95.6677 28.6531C94.7177 28.6531 94.0407 28.2181 93.6057 27.3641L99.2927 25.0121L99.0997 24.5301ZM93.2997 25.9481C93.2517 24.3041 94.5727 23.4671 95.5237 23.4671C96.2647 23.4671 96.8927 23.8381 97.1027 24.3691L93.2997 25.9481ZM88.6767 30.0721H90.5447V17.5711H88.6767V30.0721ZM85.6147 22.7741H85.5507C85.1317 22.2741 84.3257 21.8231 83.3117 21.8231C81.1847 21.8231 79.2357 23.6921 79.2357 26.0931C79.2357 28.4771 81.1847 30.3301 83.3117 30.3301C84.3267 30.3301 85.1317 29.8791 85.5507 29.3641H85.6147V29.9761C85.6147 31.6031 84.7447 32.4731 83.3437 32.4731C82.1997 32.4731 81.4907 31.6521 81.2007 30.9591L79.5737 31.6361C80.0407 32.7631 81.2807 34.1491 83.3437 34.1491C85.5347 34.1491 87.3877 32.8601 87.3877 29.7181V22.0821H85.6157V22.7741H85.6147ZM83.4727 28.6551C82.1837 28.6551 81.1047 27.5751 81.1047 26.0931C81.1047 24.5941 82.1837 23.4991 83.4727 23.4991C84.7447 23.4991 85.7437 24.5941 85.7437 26.0931C85.7437 27.5751 84.7447 28.6551 83.4727 28.6551ZM107.854 17.5711H103.383V30.0721H105.248V25.3361H107.853C109.921 25.3361 111.955 23.8391 111.955 21.4541C111.955 19.0691 109.922 17.5711 107.854 17.5711ZM107.902 23.5961H105.248V19.3111H107.902C109.297 19.3111 110.089 20.4661 110.089 21.4541C110.089 22.4221 109.297 23.5961 107.902 23.5961ZM119.434 21.8011C118.083 21.8011 116.684 22.3961 116.105 23.7151L117.761 24.4061C118.115 23.7151 118.775 23.4891 119.466 23.4891C120.431 23.4891 121.412 24.0681 121.428 25.0971V25.2261C121.09 25.0331 120.366 24.7441 119.482 24.7441C117.697 24.7441 115.879 25.7251 115.879 27.5581C115.879 29.2311 117.343 30.3081 118.983 30.3081C120.237 30.3081 120.929 29.7451 121.363 29.0851H121.427V30.0501H123.229V25.2571C123.23 23.0391 121.572 21.8011 119.434 21.8011ZM119.208 28.6521C118.598 28.6521 117.745 28.3461 117.745 27.5901C117.745 26.6251 118.807 26.2551 119.724 26.2551C120.543 26.2551 120.93 26.4321 121.428 26.6731C121.283 27.8321 120.286 28.6521 119.208 28.6521ZM129.791 22.0741L127.652 27.4941H127.588L125.368 22.0741H123.358L126.687 29.6491L124.789 33.8631H126.735L131.866 22.0741H129.791ZM112.985 30.0721H114.85V17.5711H112.985V30.0721Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const AppleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "137px",
        height: "41px",
        fill: "none",
      }}
      width="137"
      height="41"
      viewBox="0 0 137 41"
      fill="none"
    >
      <rect x="0.865723" y="0.5" width="135.234" height="40" rx="20" fill="white" />
      <path
        d="M33.7016 21.2881C33.7263 19.3755 34.7534 17.5657 36.3828 16.564C35.3549 15.0959 33.6331 14.1651 31.8418 14.109C29.9312 13.9085 28.079 15.2523 27.1054 15.2523C26.113 15.2523 24.614 14.129 22.9998 14.1622C20.8958 14.2301 18.9343 15.4264 17.9106 17.2658C15.7102 21.0756 17.3515 26.6746 19.4594 29.7541C20.514 31.262 21.7465 32.9464 23.3592 32.8867C24.9374 32.8212 25.5268 31.8803 27.4317 31.8803C29.319 31.8803 29.872 32.8867 31.5175 32.8487C33.2109 32.8212 34.2778 31.3341 35.2954 29.8118C36.0531 28.7374 36.6362 27.5499 37.023 26.2933C35.0329 25.4516 33.7039 23.4488 33.7016 21.2881Z"
        fill="black"
      />
      <path
        d="M30.5936 12.0838C31.5169 10.9754 31.9718 9.55071 31.8617 8.1123C30.451 8.26047 29.148 8.93466 28.2122 10.0006C27.2971 11.042 26.8209 12.4416 26.9109 13.825C28.3221 13.8396 29.7093 13.1836 30.5936 12.0838Z"
        fill="black"
      />
      <path
        d="M47.9856 8.24878V14.2378H50.1479C51.9326 14.2378 52.9661 13.1379 52.9661 11.2246C52.9661 9.34033 51.9243 8.24878 50.1479 8.24878H47.9856ZM48.9153 9.09546H50.0442C51.2852 9.09546 52.0198 9.88403 52.0198 11.2371C52.0198 12.6108 51.2976 13.3911 50.0442 13.3911H48.9153V9.09546Z"
        fill="black"
      />
      <path
        d="M56.1312 14.325C57.451 14.325 58.2603 13.4409 58.2603 11.9758C58.2603 10.519 57.4468 9.63086 56.1312 9.63086C54.8113 9.63086 53.9979 10.519 53.9979 11.9758C53.9979 13.4409 54.8072 14.325 56.1312 14.325ZM56.1312 13.5322C55.355 13.5322 54.9192 12.9636 54.9192 11.9758C54.9192 10.9963 55.355 10.4236 56.1312 10.4236C56.9031 10.4236 57.3431 10.9963 57.3431 11.9758C57.3431 12.9595 56.9031 13.5322 56.1312 13.5322Z"
        fill="black"
      />
      <path
        d="M65.1524 9.71802H64.2601L63.4549 13.167H63.3844L62.4547 9.71802H61.5997L60.67 13.167H60.6036L59.7943 9.71802H58.8895L60.1346 14.2378H61.0519L61.9815 10.9092H62.0521L62.9859 14.2378H63.9115L65.1524 9.71802Z"
        fill="black"
      />
      <path
        d="M66.1801 14.2378H67.0724V11.594C67.0724 10.8884 67.4916 10.4485 68.1515 10.4485C68.8114 10.4485 69.1269 10.8096 69.1269 11.5359V14.2378H70.0192V11.3118C70.0192 10.2368 69.463 9.63086 68.4545 9.63086C67.7738 9.63086 67.3256 9.93384 67.1056 10.436H67.0392V9.71802H66.1801V14.2378Z"
        fill="black"
      />
      <path d="M71.4245 14.2378H72.3168V7.9541H71.4245V14.2378Z" fill="black" />
      <path
        d="M75.6729 14.325C76.9927 14.325 77.802 13.4409 77.802 11.9758C77.802 10.519 76.9885 9.63086 75.6729 9.63086C74.353 9.63086 73.5396 10.519 73.5396 11.9758C73.5396 13.4409 74.3489 14.325 75.6729 14.325ZM75.6729 13.5322C74.8967 13.5322 74.4609 12.9636 74.4609 11.9758C74.4609 10.9963 74.8967 10.4236 75.6729 10.4236C76.4448 10.4236 76.8848 10.9963 76.8848 11.9758C76.8848 12.9595 76.4448 13.5322 75.6729 13.5322Z"
        fill="black"
      />
      <path
        d="M80.4607 13.5613C79.9751 13.5613 79.6224 13.3247 79.6224 12.918C79.6224 12.5195 79.9046 12.3079 80.5271 12.2664L81.6311 12.1958V12.5735C81.6311 13.1338 81.1331 13.5613 80.4607 13.5613ZM80.2325 14.3125C80.826 14.3125 81.3199 14.0552 81.5896 13.6028H81.6602V14.2378H82.5193V11.1499C82.5193 10.1953 81.8802 9.63086 80.7471 9.63086C79.722 9.63086 78.9915 10.1289 78.9002 10.905H79.7635C79.8631 10.5854 80.2076 10.4028 80.7056 10.4028C81.3157 10.4028 81.6311 10.6726 81.6311 11.1499V11.54L80.4068 11.6106C79.3318 11.677 78.7259 12.146 78.7259 12.9595C78.7259 13.7854 79.3609 14.3125 80.2325 14.3125Z"
        fill="black"
      />
      <path
        d="M85.5475 14.3125C86.17 14.3125 86.6971 14.0178 86.9669 13.5239H87.0374V14.2378H87.8924V7.9541H87.0001V10.436H86.9337C86.6888 9.93799 86.1659 9.64331 85.5475 9.64331C84.4061 9.64331 83.6715 10.5481 83.6715 11.9758C83.6715 13.4077 84.3978 14.3125 85.5475 14.3125ZM85.8006 10.4443C86.5477 10.4443 87.0167 11.0378 87.0167 11.98C87.0167 12.9263 86.5519 13.5115 85.8006 13.5115C85.0453 13.5115 84.5929 12.9346 84.5929 11.9758C84.5929 11.0254 85.0494 10.4443 85.8006 10.4443Z"
        fill="black"
      />
      <path
        d="M93.6789 14.325C94.9987 14.325 95.8081 13.4409 95.8081 11.9758C95.8081 10.519 94.9946 9.63086 93.6789 9.63086C92.3591 9.63086 91.5456 10.519 91.5456 11.9758C91.5456 13.4409 92.3549 14.325 93.6789 14.325ZM93.6789 13.5322C92.9028 13.5322 92.467 12.9636 92.467 11.9758C92.467 10.9963 92.9028 10.4236 93.6789 10.4236C94.4509 10.4236 94.8908 10.9963 94.8908 11.9758C94.8908 12.9595 94.4509 13.5322 93.6789 13.5322Z"
        fill="black"
      />
      <path
        d="M96.9893 14.2378H97.8816V11.594C97.8816 10.8884 98.3008 10.4485 98.9607 10.4485C99.6206 10.4485 99.936 10.8096 99.936 11.5359V14.2378H100.828V11.3118C100.828 10.2368 100.272 9.63086 99.2637 9.63086C98.583 9.63086 98.1348 9.93384 97.9148 10.436H97.8484V9.71802H96.9893V14.2378Z"
        fill="black"
      />
      <path
        d="M104.938 8.59326V9.73877H104.22V10.49H104.938V13.0425C104.938 13.9141 105.332 14.2627 106.324 14.2627C106.499 14.2627 106.665 14.2419 106.81 14.217V13.4741C106.685 13.4866 106.607 13.4949 106.47 13.4949C106.025 13.4949 105.83 13.2874 105.83 12.8142V10.49H106.81V9.73877H105.83V8.59326H104.938Z"
        fill="black"
      />
      <path
        d="M108.008 14.2378H108.9V11.5981C108.9 10.9133 109.307 10.4526 110.037 10.4526C110.668 10.4526 111.004 10.8179 111.004 11.54V14.2378H111.897V11.3201C111.897 10.2451 111.303 9.63501 110.34 9.63501C109.66 9.63501 109.182 9.93799 108.962 10.4443H108.892V7.9541H108.008V14.2378Z"
        fill="black"
      />
      <path
        d="M115.116 10.3904C115.776 10.3904 116.207 10.8511 116.228 11.5608H113.945C113.995 10.8552 114.456 10.3904 115.116 10.3904ZM116.224 13.0176C116.058 13.3704 115.688 13.5654 115.149 13.5654C114.435 13.5654 113.974 13.0632 113.945 12.2705V12.2207H117.137V11.9094C117.137 10.49 116.377 9.63086 115.12 9.63086C113.846 9.63086 113.036 10.5481 113.036 11.9924C113.036 13.4368 113.829 14.325 115.124 14.325C116.157 14.325 116.88 13.8269 117.083 13.0176H116.224Z"
        fill="black"
      />
      <path
        d="M92.0966 18.7521V21.0431H90.6606V22.5456H92.0966V27.6506C92.0966 29.3937 92.8852 30.091 94.8691 30.091C95.2177 30.091 95.5497 30.0495 95.8403 29.9997V28.5138C95.5912 28.5388 95.4335 28.5554 95.1596 28.5554C94.2714 28.5554 93.8813 28.1403 93.8813 27.194V22.5456H95.8403V21.0431H93.8813V18.7521H92.0966Z"
        fill="black"
      />
      <path
        d="M100.894 30.2155C103.534 30.2155 105.152 28.4474 105.152 25.5173C105.152 22.6037 103.525 20.8273 100.894 20.8273C98.2545 20.8273 96.6275 22.6037 96.6275 25.5173C96.6275 28.4474 98.2462 30.2155 100.894 30.2155ZM100.894 28.6301C99.3419 28.6301 98.4703 27.4929 98.4703 25.5173C98.4703 23.5583 99.3419 22.4128 100.894 22.4128C102.438 22.4128 103.318 23.5583 103.318 25.5173C103.318 27.4846 102.438 28.6301 100.894 28.6301Z"
        fill="black"
      />
      <path
        d="M106.537 30.0412H108.322V24.7038C108.322 23.4338 109.277 22.5788 110.63 22.5788C110.945 22.5788 111.476 22.6369 111.626 22.6867V20.9269C111.435 20.8771 111.094 20.8522 110.829 20.8522C109.65 20.8522 108.646 21.4997 108.388 22.3879H108.256V21.0016H106.537V30.0412Z"
        fill="black"
      />
      <path
        d="M116.057 22.3464C117.377 22.3464 118.24 23.2678 118.282 24.6872H113.716C113.816 23.2761 114.737 22.3464 116.057 22.3464ZM118.273 27.6008C117.941 28.3063 117.202 28.6965 116.123 28.6965C114.696 28.6965 113.774 27.6921 113.716 26.1066V26.007H120.099V25.3845C120.099 22.5456 118.58 20.8273 116.065 20.8273C113.517 20.8273 111.898 22.6618 111.898 25.5505C111.898 28.4391 113.484 30.2155 116.074 30.2155C118.14 30.2155 119.585 29.2194 119.992 27.6008H118.273Z"
        fill="black"
      />
      <path
        d="M80.393 26.703C80.5307 28.9227 82.3804 30.3423 85.1336 30.3423C88.076 30.3423 89.9171 28.8539 89.9171 26.4793C89.9171 24.6124 88.8675 23.58 86.3208 22.9863L84.9529 22.6508C83.3354 22.2722 82.6816 21.7646 82.6816 20.8784C82.6816 19.76 83.6968 19.0287 85.2196 19.0287C86.665 19.0287 87.663 19.7428 87.8437 20.8871H89.7192C89.6074 18.7964 87.7662 17.3252 85.2454 17.3252C82.5353 17.3252 80.7286 18.7964 80.7286 21.0075C80.7286 22.8314 81.7524 23.9155 83.9979 24.4403L85.5981 24.8275C87.2414 25.2146 87.9641 25.7825 87.9641 26.7288C87.9641 27.8301 86.8285 28.6302 85.2798 28.6302C83.6193 28.6302 82.4665 27.8817 82.303 26.703H80.393Z"
        fill="black"
      />
      <path
        d="M61.9057 20.8522C60.6772 20.8522 59.6147 21.4665 59.0668 22.4958H58.934V21.0016H57.2157V33.0461H59.0004V28.6716H59.1415C59.6147 29.6262 60.6357 30.1906 61.9223 30.1906C64.205 30.1906 65.6576 28.3893 65.6576 25.5173C65.6576 22.6452 64.205 20.8522 61.9057 20.8522ZM61.3993 28.5886C59.9052 28.5886 58.9672 27.4098 58.9672 25.5256C58.9672 23.633 59.9052 22.4543 61.4076 22.4543C62.9184 22.4543 63.8232 23.6081 63.8232 25.5173C63.8232 27.4347 62.9184 28.5886 61.3993 28.5886Z"
        fill="black"
      />
      <path
        d="M71.9025 20.8522C70.674 20.8522 69.6115 21.4665 69.0636 22.4958H68.9308V21.0016H67.2125V33.0461H68.9972V28.6716H69.1383C69.6115 29.6262 70.6325 30.1906 71.9191 30.1906C74.2018 30.1906 75.6544 28.3893 75.6544 25.5173C75.6544 22.6452 74.2018 20.8522 71.9025 20.8522ZM71.3961 28.5886C69.902 28.5886 68.964 27.4098 68.964 25.5256C68.964 23.633 69.902 22.4543 71.4044 22.4543C72.9152 22.4543 73.82 23.6081 73.82 25.5173C73.82 27.4347 72.9152 28.5886 71.3961 28.5886Z"
        fill="black"
      />
      <path
        d="M54.0137 30.0412H56.0614L51.579 17.6263H49.5055L45.0231 30.0412H47.0019L48.1461 26.746H52.8781L54.0137 30.0412ZM50.4433 19.8804H50.5895L52.3877 25.1286H48.6365L50.4433 19.8804Z"
        fill="black"
      />
    </SvgIcon>
  );
};
